import ErrorPage from "@/pages/_error";
import { PropsWithChildren } from "react";
import { IntlShape, useIntl } from "react-intl";

type ActivityKind = "event" | "competition";

interface Props extends PropsWithChildren {
  readonly kind: ActivityKind;
}

function formatActivityNotFoundMessage(intl: IntlShape, kind: ActivityKind) {
  switch (kind) {
    case "event":
      return intl.formatMessage({ defaultMessage: "Challenge not found" });
    case "competition":
      return intl.formatMessage({ defaultMessage: "Track not found " });
  }
}

export function ActivityNotFound(props: Props) {
  const intl = useIntl();

  return (
    <ErrorPage
      status={404}
      message={formatActivityNotFoundMessage(intl, props.kind)}
    >
      {props.children}
    </ErrorPage>
  );
}
